
<template >
  <d2-container>
    <div style="text-align: left; padding-top: 20px; font-size: 17px">
      <div class="infoFormTitle">
        采购申请人：{{ discountApply && discountApply.userName }}
      </div>
      <div class="infoFormTitle" style="word-break: break-all">
        采购物品：{{ discountApply && discountApply.goodsDesc }}
      </div>

      <div class="infoFormTitle">
        预算金额：{{ discountApply && discountApply.budgetMoney }}元
      </div>
    </div>
    <el-form
      ref="infoForm"
      label-position="top"
      v-if="discountApply && (discountApply.remark || imageList.length > 0)"
    >
      <div v-if="imageList.length > 0">
        <div class="infoFormTitle">附件：</div>
        <div class="formItemImage">
          <div
            v-for="(item, index) in imageList"
            :key="index"
            class="Imageuploader"
          >
            <el-image
              class="elImageClass"
              :src="item"
              :preview-src-list="imageList"
            />
            <!-- <img :src="item" alt="" /> -->
          </div>
        </div>
      </div>
      <div v-if="discountApply && discountApply.remark">
        <div class="infoFormTitle">申请备注：</div>
        <div style="word-break: break-all; margin-left: 20px">
          {{ discountApply && discountApply.remark }}
        </div>
      </div>
    </el-form>
    <el-timeline class="timelineBox">
      <el-timeline-item
        v-for="(activity, index) in stepsList"
        :key="index"
        :timestamp="
          activity.approvateTime
            ? fmtDate(activity.approvateTime, 'yyyy-MM-dd HH:mm')
            : ''
        "
      >
        {{ activity.approvateUserName }}
      </el-timeline-item>
    </el-timeline>

    <div
      style="text-align: center; padding-top: 1rem"
      v-if="
        isEnd &&
        (isEnd.approvateState == 'WAIT' || isEnd.approvateState == 'REJECT')
      "
    >
      <el-form ref="remarkForm" :model="info">
        <el-form-item label="驳回原因" prop="remark">
          <el-input
            v-model="info.remark"
            autocomplete="off"
            :readonly="isEnd.approvateState == 'REJECT'"
            style="width: 88%"
          ></el-input>
        </el-form-item>
      </el-form>

      <div
        style="padding-top: 10px"
        v-if="isEnd && isEnd.approvateState == 'WAIT'"
      >
        <el-button
          type="success"
          @click="onSubmit('AGREE')"
          style="width: 90%; height: 3rem; font-size: 1.5rem"
          >通过</el-button
        >
      </div>
      <div
        style="padding-top: 10px"
        v-if="isEnd && isEnd.approvateState == 'WAIT'"
      >
        <el-button
          type="success"
          @click="onSubmit('REJECT')"
          style="width: 90%; height: 3rem; font-size: 1.5rem; margin-left: 0px"
          >拒绝</el-button
        >
      </div>
    </div>
    <div style="text-align: center; padding-top: 2rem" v-if="isEnd">
      <i
        class="el-icon-success"
        style="font-size: 4em; color: #07c160"
        v-if="isEnd.approvateState == 'AGREE'"
      ></i>
      <el-button
        type="success"
        disabled
        v-if="isEnd.approvateState == 'AGREE'"
        style="width: 90%; height: 3rem; font-size: 1.5rem; margin-top: 1rem"
        >申请已通过</el-button
      >
      <i
        class="el-icon-error"
        style="font-size: 4em; color: #cc5656"
        v-if="isEnd.approvateState == 'REJECT'"
      ></i>
      <el-button
        type="success"
        disabled
        v-if="isEnd.approvateState == 'REJECT'"
        style="width: 90%; height: 3rem; font-size: 1.5rem; margin-top: 1rem"
        >申请未通过</el-button
      >
    </div>
  </d2-container>
</template>
<script>
import { mapActions } from "vuex";
import util from "@/libs/util";
import dateUtil from "@/utils/dateUtil";
export default {
  title: "自定义列模板",
  index: 14,
  data() {
    return {
      reverse: true,
      stepsList: [],
      imageList: [],
      openId: this.$route.query.openid, //微信openid可以确定user
      id: this.$route.query.id, //优惠申请id
      discountApply: null,
      userInfo: {},
      isEnd: null,
      info: {
        remark: ''
      }
    };
  },
  methods: {
    ...mapActions("d2admin/purchasing", [
      "getUser",
      "getPurchaseRequisition",
      "setPurchaseRequisitionDetail"
    ]),
    onSubmit(isAgree) {
      if (isAgree == 'REJECT' && !this.info.remark) {
        this.$alert('请填写驳回原因', '操作提示', {
          confirmButtonText: '确定'
        })
        return
      }
      this.loading = this.$loading({
        fullscreen: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.6)",
      });
      let parm = {
        purchaseRequisitionId: this.$route.query.id,
        approvateLevel: this.userInfo.approvallerLevel,
        approvateState: isAgree,
        rejectReason: this.info.remark,
        openId: this.openId,
        approvateUserName: this.userInfo.nickName,
        approvateUserId: this.userInfo.id,
        approvateTime: new Date().getTime()
      }
      this.setPurchaseRequisitionDetail(parm).then((res) => {
        if (res.data.result == 1) {
          this.loading.close()
          this.$alert('处理成功', '操作提示', {
            confirmButtonText: '确定'
          })
          this.reresh()
        } else {
          this.$alert(res.data.message, '操作提示', {
            confirmButtonText: '确定'
          })
          this.loading.close()
          this.reresh()
        }
      })
    },
    onGetUser() {
      this.getUser({ openId: this.openId }).then((res) => {
        if (res.data.result == "1") {
          this.userInfo = res.data.data.alias1
          this.reresh();
        } else {
          this.$alert(res.data.message, '操作提示', {
            confirmButtonText: '确定'
          })
        }
      }).catch((err) => {

      });
    },
    fmtDate(date, fmt) {
      return dateUtil.formatDate(date, fmt);
    },
    reresh() {
      this.getPurchaseRequisition({ id: this.$route.query.id, userId: this.userInfo.id }).then((res) => {
        if (res.data.result == "1") {
          this.discountApply = res.data.data.PurchaseRequisition
          this.info.remark = this.discountApply.rejectReason
          this.discountApply.openid = this.$route.query.openid
          if (res.data.data.PurchaseRequisition.imgFile) {
            let imageList = this.discountApply.imgFile.split(",")
            if (imageList.length > 0 && imageList[0] != '') {
              this.imageList = this.discountApply.imgFile.split(",")
            }
          }
          if (res.data.data.PurchaseRequisitionDetailList && res.data.data.PurchaseRequisitionDetailList.length > 0) {
            let purchaseRequisitionDetailList = res.data.data.PurchaseRequisitionDetailList
            purchaseRequisitionDetailList.unshift({
              approvateState: "AGREE",
              approvateTime: this.discountApply.createTime,
              approvateUserName: "申请已提交",
            })
            for (let j = 0; j < purchaseRequisitionDetailList.length; j++) {
              const element = purchaseRequisitionDetailList[j];
              if (!element.approvateUserName) {
                if (element.approvateLevel == 1) {
                  element.approvateUserName = '一级审核-' + (element.approvateState == 'WAIT' ? '待审核' : element.approvateState == 'AGREE' ? '已审核' : element.approvateState == 'REJECT' ? '已驳回' : '')
                } else if (element.approvateLevel == 2) {
                  element.approvateUserName = '二级审核-' + (element.approvateState == 'WAIT' ? '待审核' : element.approvateState == 'AGREE' ? '已审核' : element.approvateState == 'REJECT' ? '已驳回' : '')
                } else {
                  element.approvateUserName = '三级审核-' + (element.approvateState == 'WAIT' ? '待审核' : element.approvateState == 'AGREE' ? '已审核' : element.approvateState == 'REJECT' ? '已驳回' : '')
                }
              } else if (element.approvateUserName !== "申请已提交") {
                element.approvateUserName = element.approvateUserName + '-' + (element.approvateState == 'WAIT' ? '待审核' : element.approvateState == 'AGREE' ? '已审核' : element.approvateState == 'REJECT' ? '已驳回' : '')
              }
              if (element.approvateState == 'AGREE' || element.approvateState == 'REJECT') {
                this.number1 = this.number1 + 1
              } else if (element.approvateState == 'WAIT') {
                this.waitActive = this.waitActive + 1
                if (this.waitActive <= 1) {
                  this.number1 = this.number1 + 1
                }
              }
            }
            this.stepsList = purchaseRequisitionDetailList
          }
          this.isEnd = res.data.data.isEnd
        } else {
          this.$alert(res.data.message, '操作提示', {
            confirmButtonText: '确定'
          })
        }
      })
    },
  },
  mounted() {
    this.onGetUser()
    this.reresh();
  },
};
</script>
<style lang="scss">
.el-message-box {
  width: 80%;
}
.d2-container-full__body {
  padding: 0px 20px;
  overflow: hidden;
}
.formItemImage {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Imageuploader {
  width: 142px;
  height: 142px;
  margin-bottom: 10px;
  position: relative;
}
.elImageClass {
  width: 100%;
  height: 100%;
}
.infoFormTitle {
  margin-bottom: 10px;
}
.timelineBox {
  padding-top: 30px;
  padding-left: 0px;
}
</style>